import AddIcon from '@mui/icons-material/Add';
import { Stack } from '@mui/material';
import PaiIconButton from 'features/ui/base-components/pai-icon-button';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import _ from 'lodash';
import React from 'react';
import BlacklistItemChip from './blacklist-item-chip';
import { useTranslation } from 'react-i18next';
import { BlacklistTypes } from './company-blacklist.types';

interface Props {
  textfield: string;
  textFieldError: true | null;
  list: string[];
  blacklistType: BlacklistTypes;

  handleTextFieldChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleAddIndividualItem(): void;

  handlePasteIndividualItem(event: React.ClipboardEvent): void;

  handleRemoveIndividualItem(idx: number): () => void;
}

const AddIndividualItems: React.FC<Props> = ({
  textfield,
  textFieldError,
  list,
  blacklistType,
  handleTextFieldChange,
  handleAddIndividualItem,
  handlePasteIndividualItem,
  handleRemoveIndividualItem,
}) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <Stack direction={'row'} alignItems={'center'} gap={2}>
        <PaiTextField
          placeholder={t('pressEnterOrClick')}
          value={textfield}
          error={!_.isNil(textFieldError)}
          errorText={t('invalidLinkedInUrl')}
          onChange={handleTextFieldChange}
          onPaste={handlePasteIndividualItem}
          onKeyDown={(event: React.KeyboardEvent) => {
            if (event.key === 'Enter') {
              handleAddIndividualItem();
            }
          }}
        />
        <PaiIconButton size={'small'} onClick={handleAddIndividualItem} disabled={!textfield.trim()}>
          <AddIcon />
        </PaiIconButton>
      </Stack>

      {!_.isEmpty(list) ? (
        <Stack direction={'row'} gap={1} flexWrap={'wrap'} sx={{ maxWidth: '700px' }}>
          {list.map((item, index) => (
            <BlacklistItemChip key={index} label={item} blacklistType={blacklistType} handleRemove={handleRemoveIndividualItem(index)} />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
};

export default AddIndividualItems;
